"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentManualList = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _types = _interopRequireDefault(require("./types"));
var _excluded = ["type", "cards", "callback", "resendHandler"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var PaymentManualList = function PaymentManualList(_ref) {
  var type = _ref.type,
    cards = _ref.cards,
    callback = _ref.callback,
    resendHandler = _ref.resendHandler,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion, null, /*#__PURE__*/_react.default.createElement(_types.default[type], _objectSpread(_objectSpread(_objectSpread({}, type === 'card' && {
    cards: cards
  }), type !== 'info' && {
    callback: callback,
    resendHandler: resendHandler
  }), props)));
};
exports.PaymentManualList = PaymentManualList;
PaymentManualList.propTypes = {
  platform: _propTypes.default.oneOf(['web', 'mob']),
  type: _propTypes.default.oneOf(['card', 'wallet', 'other', 'cashDesk']),
  actionType: _propTypes.default.oneOf(['deposit', 'withdraw']),
  cards: _propTypes.default.array,
  callback: _propTypes.default.func
};
PaymentManualList.defaultProps = {
  platform: 'web',
  type: 'card',
  actionType: 'deposit',
  cards: []
};